import { ColumnType } from '../utils/type';
import { getCellText, highlightText } from '../utils/text';

export function Body<T>({
  rows,
  columns,
  term,
  highlight
}: {
  rows: T[];
  columns: ColumnType<T>[];
  term: string;
  highlight: boolean;
}) {
  return (
    <tbody>
      {rows.map((row, r) => (
        <tr key={r}>
          {columns.map((c, i) => {
            const raw = c.cell ? c.cell(row) : c.selector?.(row);
            return (
              <td
                key={i}
                className={c.center ? 'text-center' : ''}
                style={{
                  position: c.fixed ? 'sticky' : undefined,
                  left: c.fixed === 'left' ? 0 : undefined,
                  right: c.fixed === 'right' ? 0 : undefined,
                  background: c.fixed ? '#fff' : undefined
                }}
              >
                {highlight && term ? highlightText(getCellText(raw), term) : raw}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
}
